import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuantityInputModule } from './quantity-input/quantity-input.module';
import { ProductPriceModule } from '../product-price/product-price.module';
import { ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '../../directives/directives.module';
import { ProductListComponent } from './product-list.component';
import { createCustomElement } from '@angular/elements';
import { PipesModule } from '../../pipes/pipes.module';
import { QuantityDiscountModule } from './quantity-discount/quantity-discount.module';
import { SanitizePipeModule } from '@digistore/ds24-ui/pipes';
import { DialogModule } from 'primeng/dialog';
import { SharedModule } from 'primeng/api';
import { VarPipeModule } from '@digistore/ds24-ui/var-pipe';
import { InputsGeneratorModule } from '../inputs-generator/inputs-generator.module';

@NgModule({
  declarations: [ProductListComponent],
  imports: [
    CommonModule,
    QuantityInputModule,
    ProductPriceModule,
    ReactiveFormsModule,
    DirectivesModule,
    PipesModule,
    SanitizePipeModule,
    QuantityDiscountModule,
    DialogModule,
    SharedModule,
    VarPipeModule,
    InputsGeneratorModule,
  ],
  exports: [ProductListComponent],
})
export class ProductListModule {
  static initialize(injector: Injector) {
    const customComponent = createCustomElement(ProductListComponent, {
      injector: injector,
    });
    customElements.define('ds-orderform-product-list', customComponent);
  }
}
